/**
 * @license
 * Copyright 2026 Kai-Orion & Sandlada
 * SPDX-License-Identifier: MIT
 */
import {
    FilledFieldDefinition,
    OutlinedFieldDefinition,
} from './field.definition'

export const FilledTextFieldDefinition = FilledFieldDefinition
export const OutlinedTextFieldDefinition = OutlinedFieldDefinition
export const TextFieldDefinition = FilledTextFieldDefinition
